import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { ElMessage } from 'element-plus';

import ChartEx from '@/assets/img/ChartEx.png';
import ChartExAlert from '@/assets/img/ChartExAlert.png';
import ChartExAlertEn from '@/assets/img/ChartExAlertEn.png';
import ChartExCalculate from '@/assets/img/ChartExCalculate.png';
import ChartExCalculateEn from '@/assets/img/ChartExCalculateEn.png';
import ChartExEdit from '@/assets/img/ChartExEdit.png';
import ChartExEditEn from '@/assets/img/ChartExEditEn.png';
import videoMenuOtherFunctionTw from '@/assets/video/videoMenuOtherFunction-tw.mp4';
import videoMenuOtherFunctionEn from '@/assets/video/videoMenuOtherFunction-en.mp4';
import videoMenuOtherFunctionCn from '@/assets/video/videoMenuOtherFunction-cn.mp4';

/**
 * 呼叫儀表板
 * @param {*} i18n
 */
export function callHelpDashboard(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.navbar-brand.ms-1',
        popover: {
          title: i18n.$t('Dashboard').brand,
          description: i18n.$t('Dashboard').dashboardDescription,
        },
      },
      {
        element: '#setBtn',
        popover: {
          title: i18n.$t('Dashboard').set,
          description: i18n.$t('Dashboard').setExplain,
          onNextClick: () => {
            if (store.state.dashboard.dashboardSettingVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickTheButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(1);
              }, 3000);
            }
          },
        },
      },
      {
        element: '#setDialog',
        popover: {
          title: i18n.$t('Dashboard').setChart,
          description: i18n.$t('Dashboard').setChartExplain,
        },
      },
      {
        element: '#refreshBtn',
        popover: {
          title: i18n.$t('Dashboard').refresh,
          description:
            store.state.dashboard.kanbanDataLength > 0
              ? i18n.$t('Dashboard').refreshExplain
              : i18n.$t('Dashboard').refreshExplainIfNoSetting,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫樣本點檢視協助
 * @param {*} i18n
 */
export function callHelpSamplePointView(i18n, store) {
  const htmlContextSample = `
  <img src='${ChartEx}' width="900"></img>
  <p>${i18n.$t('Dashboard').SamplePointViewExplain}</p>
  `;

  let imgAlert = null;
  let imgCalculation = null;
  let imgEdit = null;

  switch (store.state.lang) {
    case 'zhtw':
    case 'cn':
      imgAlert = ChartExAlert;
      imgCalculation = ChartExCalculate;
      imgEdit = ChartExEdit;
      break;

    case 'en':
      imgAlert = ChartExAlertEn;
      imgCalculation = ChartExCalculateEn;
      imgEdit = ChartExEditEn;
      break;

    default:
      imgAlert = ChartExAlert;
      imgCalculation = ChartExCalculate;
      imgEdit = ChartExEdit;
      break;
  }

  const htmlContextAlertHandle = `
  <img src='${imgAlert}' width="780"></img>
  <p>${i18n.$t('Dashboard').AlertHandleExplain}</p>
  `;

  const htmlContextCalculateSource = `
  <img src='${imgCalculation}' width="900"></img>
  <p>${i18n.$t('Dashboard').CalculateSourceExplain}</p>
  `;

  const htmlContextEditCalculateValue = `
  <img src='${imgEdit}' width="900"></img>
  <p>${i18n.$t('Dashboard').EditCalculateValueExplain}</p>
  `;

  const driverObj = driver({
    popoverClass: 'classChartEx',
    showProgress: true,
    steps: [
      {
        popover: {
          title: i18n.$t('Dashboard').SamplePointView,
          description: htmlContextSample,
        },
      },
      {
        popover: {
          title: i18n.$t('Dashboard').AlertHandle,
          description: htmlContextAlertHandle,
        },
      },
      {
        popover: {
          title: i18n.$t('Dashboard').CalculateSource,
          description: htmlContextCalculateSource,
        },
      },
      {
        popover: {
          title: i18n.$t('Dashboard').EditCalculateValue,
          description: htmlContextEditCalculateValue,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫 選單->其他功能
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpMenuOtherFunction(i18n, store) {
  let videoSource = null;

  switch (store.state.lang) {
    case 'zhtw':
      videoSource = videoMenuOtherFunctionTw;
      break;

    case 'en':
      videoSource = videoMenuOtherFunctionEn;
      break;

    case 'cn':
      videoSource = videoMenuOtherFunctionCn;
      break;

    default:
      videoSource = videoMenuOtherFunctionTw;
      break;
  }

  const video = `
  <p>${i18n.$t('Dashboard').MenuOtherFunctionEnableEdit}</p>
  <video width="800" controls>
    <source src='${videoSource}' type="video/mp4">
  </video>`;

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#menu',
        popover: {
          side: 'top',
          align: 'center',
          title: i18n.$t('Dashboard').MenuOtherFunction,
          description: video,
          popoverClass: 'videoExplain',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}
